var map = {
	"./main": 9079,
	"./main.js": 9079,
	"./src/data": 1817,
	"./src/data.json": 1817,
	"./src/images/img1.jpg": 1392,
	"./src/images/img2.jpg": 9626,
	"./src/meta": 2139,
	"./src/meta.json": 2139,
	"./src/style.scss": 495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 697;